import { clickSignUpButtonTracker, signUpValidationFailedTracker } from '@/utils/analytics/gtm';

const BOUND_FLAG = 'ablySignupTrackersBound';

export default function getSingupValidationTrackers(): void {
  let signupValidationError = false;
  let hasSentSignupError = false;

  const form = document.querySelector<HTMLFormElement>('#new_user');
  if (form !== null && !form.dataset[BOUND_FLAG]) {
    form.dataset[BOUND_FLAG] = 'true';
    // The legacy form surfaces validation errors by injecting a server-rendered
    // `#new-user-msgbox` node, not through React, so a MutationObserver is the
    // only way to notice a failure and keep the GTM funnel event firing.
    const observer = new MutationObserver((nodeList) => {
      const errorMessageContainer = nodeList.find(
        (element) => (element.target as HTMLElement).id === 'new-user-msgbox',
      );
      if (hasSentSignupError) return;
      if (errorMessageContainer) signupValidationError = true;
      if (signupValidationError) {
        hasSentSignupError = true;
        signUpValidationFailedTracker();
      }
    });

    const observerOptions = {
      childList: true,
      subtree: true,
    };

    observer.observe(form, observerOptions);
  }

  const clickHandler = () => {
    clickSignUpButtonTracker({ signupProvider: 'email-and-password' });
  };

  const emailSignupButton = document.querySelector<HTMLButtonElement>('#signup-button');
  if (emailSignupButton !== null && !emailSignupButton.dataset[BOUND_FLAG]) {
    emailSignupButton.dataset[BOUND_FLAG] = 'true';
    emailSignupButton.addEventListener('click', clickHandler);
  }
}
